function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z",
  fill: "none",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 32
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256 56v120a32 32 0 0032 32h120M176 288h160M176 368h160",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
});

function SvgResume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA1MTIgNTEyJz48dGl0bGU+aW9uaWNvbnMtdjUtazwvdGl0bGU+PHBhdGggZD0nTTQxNiwyMjEuMjVWNDE2YTQ4LDQ4LDAsMCwxLTQ4LDQ4SDE0NGE0OCw0OCwwLDAsMS00OC00OFY5NmE0OCw0OCwwLDAsMSw0OC00OGg5OC43NWEzMiwzMiwwLDAsMSwyMi42Miw5LjM3TDQwNi42MywxOTguNjNBMzIsMzIsMCwwLDEsNDE2LDIyMS4yNVonIHN0eWxlPSdmaWxsOm5vbmU7c3Ryb2tlOmN1cnJlbnRDb2xvcjtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjMycHgnLz48cGF0aCBkPSdNMjU2LDU2VjE3NmEzMiwzMiwwLDAsMCwzMiwzMkg0MDgnIHN0eWxlPSdmaWxsOm5vbmU7c3Ryb2tlOmN1cnJlbnRDb2xvcjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjMycHgnLz48bGluZSB4MT0nMTc2JyB5MT0nMjg4JyB4Mj0nMzM2JyB5Mj0nMjg4JyBzdHlsZT0nZmlsbDpub25lO3N0cm9rZTpjdXJyZW50Q29sb3I7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozMnB4Jy8+PGxpbmUgeDE9JzE3NicgeTE9JzM2OCcgeDI9JzMzNicgeTI9JzM2OCcgc3R5bGU9J2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MzJweCcvPjwvc3ZnPg==";
export { SvgResume as ReactComponent };